import { render } from "./TheTruongMamNonGD2.vue?vue&type=template&id=35987908"
import script from "./TheTruongMamNonGD2.vue?vue&type=script&lang=js"
export * from "./TheTruongMamNonGD2.vue?vue&type=script&lang=js"

import "./TheTruongMamNonGD2.vue?vue&type=style&index=0&id=35987908&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__